module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": ".2rem 0 8rem 0"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "order-success"
  }, [(_vm.row.erweiimg.length > 0) ? _c('img', {
    attrs: {
      "src": _vm.row.erweiimg[0].url
    }
  }) : _vm._e(), _vm._v(" "), (_vm.row.erweiimg.length > 0) ? _c('p', [_vm._v("扫码加工作人员好友，进入培训微信群")]) : _vm._e()]), _vm._v(" "), _c('van-divider', [_vm._v("场次信息")]), _vm._v(" "), _c('van-cell-group', [_c('van-cell', {
    attrs: {
      "input-align": "right",
      "title": "单位",
      "value": _vm.row.danwei
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "input-align": "right",
      "title": "场次",
      "value": _vm.row.station_name
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "input-align": "right",
      "title": "时间",
      "value": _vm.row.station.startdate + '至' + _vm.row.station.enddate
    }
  })], 1), _vm._v(" "), _c('van-divider', [_vm._v("个人信息")]), _vm._v(" "), _c('van-cell-group', [_c('van-cell', {
    attrs: {
      "input-align": "right",
      "title": "省市区",
      "value": _vm.row.province + '  ' + _vm.row.city + ' ' + _vm.row.county + ' ' + _vm.row.address
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "input-align": "right",
      "title": "姓名",
      "value": _vm.row.member.name
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "input-align": "right",
      "title": "身份证号",
      "value": _vm.row.member.num
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "input-align": "right",
      "title": "手机号",
      "value": _vm.row.member.phone
    }
  })], 1), _vm._v(" "), (_vm.row.cert_url && _vm.row.cert_url.url) ? _c('div', {
    staticClass: "cert-li"
  }, [_c('van-divider', [_vm._v("结业证书")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.row.cert_url.url,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "cert-button"
  }, [(!_vm.isApp) ? _c('van-button', {
    staticStyle: {
      "margin": "10px auto",
      "text-align": "center"
    },
    attrs: {
      "type": "default",
      "round": ""
    }
  }, [_vm._v("请长按图片保存\n      ")]) : _c('van-button', {
    staticStyle: {
      "margin": "10px auto",
      "text-align": "center"
    },
    attrs: {
      "type": "default",
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.appDownload(_vm.row.cert_url.filename, _vm.row.cert_url.url)
      }
    }
  }, [_vm._v("点击下载\n      ")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('van-divider', [_vm._v("资料信息")]), _vm._v(" "), _vm._l((_vm.row.goods_list), function(goods, index) {
    return _c('van-cell', {
      key: _vm.inedx,
      attrs: {
        "input-align": "right",
        "title": goods.item_title,
        "value": goods.count + '' + goods.unit + ' ',
        "label": goods.total_price + '元'
      }
    })
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px",
      "text-align": "center"
    }
  }, [(_vm.row.next_gjsb) ? _c('van-button', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'SongpeiApplyFormStep3',
        query: {
          id: _vm.row.id
        }
      }),
      expression: "{name:'SongpeiApplyFormStep3' ,query:{ id:row.id }}"
    }],
    staticStyle: {
      "width": "3rem",
      "margin": "0 auto"
    },
    attrs: {
      "size": "normal",
      "round": ""
    }
  }, [_vm._v("资质申报\n    ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px",
      "text-align": "center"
    }
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem",
      "margin": "0 auto"
    },
    attrs: {
      "size": "normal",
      "round": ""
    },
    on: {
      "click": _vm.toStep2
    }
  }, [_vm._v("资料订购\n    ")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px",
      "text-align": "center"
    }
  }, [(_vm.row.station.can_exame == 1) ? _c('van-button', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'SongpeiExame',
        query: {
          id: _vm.row.id
        }
      }),
      expression: "{name:'SongpeiExame' ,query:{ id:row.id }}"
    }],
    staticStyle: {
      "width": "3rem",
      "margin": "0 auto"
    },
    attrs: {
      "size": "normal",
      "round": ""
    }
  }, [_vm._v("在线考试\n    ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'SongpeiApplyList'
      }),
      expression: "{name:'SongpeiApplyList'}"
    }],
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": ""
    }
  }, [_vm._v("我的报名记录\n    ")])], 1), _vm._v(" "), _c('van-action-sheet', {
    attrs: {
      "actions": _vm.ltActions,
      "cancel-text": "取消",
      "close-on-click-action": ""
    },
    on: {
      "select": _vm.onLtSelect,
      "cancel": function($event) {
        _vm.ltShow = false
      }
    },
    model: {
      value: (_vm.ltShow),
      callback: function($$v) {
        _vm.ltShow = $$v
      },
      expression: "ltShow"
    }
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-success"
  }, [_c('div', {
    staticClass: "icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("报名成功")]), _vm._v(" "), _c('div', {
    staticClass: "desc"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-56385d90","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/songpei/SongpeiApplyFormSuccess.vue
// module id = 2401
// module chunks = 0